export enum StatusType {
  Waiting = 0,
  Approved = 1,
  Reproved = 2,
  Done = 3,
  Working = 4,
  Revision = 5,
  WaitPublish = 6,
  Published = 7,
  PreRevision = 8,
  OnHold = 9,
  ReturnToWriter = 10,
  ReviewPaused = 11,
  WaitingForTranslation = 12,
  ErrorWhenTranslating = 13,
  InTranslation = 14,
  Scheduled = 15,
  AiWriting = 16,
  AiError = 17,
  AwaitingAIWriting = 18,
}
